import React from 'react';
import Server from './Server/Server.js';
import './ServersList.css';

class ServersList extends React.Component {
    state = {
        error: null,
        isLoaded: false,
        servers: [],
        interval: null,
    };

    componentDidMount() {
        this.tick = this.tick.bind(this);
        this.tick();
        this.setState({
            interval: setInterval(this.tick, 30000)
        });
    }

    tick() {
        fetch('https://api.redwood-guild.com/servers')
            .then(res => res.json())
            .then(
                result => {
                    this.setState({
                        isLoaded: true,
                        servers: result
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                error => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            );
    }

    render() {
        const { error, isLoaded, servers } = this.state;
        if (error) {
            return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
            return <div>Loading...</div>;
        } else {
            return (
                <div className="serverlist" id="serverlist">
                    <table className="tableResponsive">
                        <tr>
                            <th>Game</th>
                            <th>Mod Pack</th>
                            <th>World Name</th>
                            <th>Hostnames</th>
                            <th>Server Status</th>
                        </tr>
                        {servers.map(server => <Server server={server} />)}
                    </table>
                </div>
            );
        }
    }
}

export default ServersList;



// WEBPACK FOOTER //
// ./src/components/ServersList/ServersList.js